import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import MediaInput from '../../components/_molecules/MediaInput/MediaInput';
import Button from '../../components/_atomic/Button/Button';
import MediaLibrary from '../../components/_molecules/MediaLibrary/MediaLibrary';
import LoadingOverlay from '../../components/_molecules/LoadingOverlay/LoadingOverlay';
import ErrorModal from '../../components/_molecules/ErrorModal/ErrorModal';
import { LOADING, ERROR, SUCCESS, publicHash, MEDIA_AUTHOR } from '../../utils/constants';
import './UploadMedia.scss';


class UploadMedia extends Component {
  static propTypes = {
    uploadMedia: PropTypes.func.isRequired,
    apps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    campaignId: PropTypes.string.isRequired,
    uploadMediaStatus: PropTypes.string.isRequired,
    uploadMediaError: PropTypes.string.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    resetStore: PropTypes.func.isRequired,
  }

  state = {
    selectedMedias: [],
  }

  componentDidUpdate(prevProps) {
    const { uploadMediaStatus, history: { push } } = this.props;
    if (prevProps.uploadMediaStatus !== uploadMediaStatus && uploadMediaStatus === SUCCESS) {
      push(`${publicHash}/app/add-payment`);
    }
  }

  mediaChangeHandler = (value) => {
    // don't destructing state, coz value is already immutable concatenated with
    // state
    const selectedMedias = [...value];
    this.setState(() => ({ selectedMedias }));
  }

  deleteItem = ({ name, size, lastModified }) => {
    const selectedMedias = [...this.state.selectedMedias];
    const itemToDelete = selectedMedias
      .findIndex(item =>
        item.name === name && item.size === size && item.lastModified === lastModified);
    selectedMedias.splice(itemToDelete, 1);
    this.setState(() => ({ selectedMedias }));
  }

  uploadMedia = () => {
    const { selectedMedias } = this.state;
    const { uploadMedia, campaignId, apps } = this.props;
    const data = {
      campaigns: campaignId,
      app: apps[0].id,
      author: MEDIA_AUTHOR.USER,
      selectedMedias,
    };
    uploadMedia(data);
  }

  renderNextButton = (itemsLength) => {
    if (itemsLength) {
      return (
        <div className="button-wrapper">
          <Button label="Next" clickHandler={this.uploadMedia} />
        </div>
      );
    }
    return null;
  }

  render() {
    const uploadMediaClassNames = classNames(['screen', 'upload-media-screen']);
    const { selectedMedias } = this.state;
    const { uploadMediaStatus, uploadMediaError, resetStore } = this.props;
    const mediasLength = selectedMedias.length;
    const buttonLabel = mediasLength
      ? 'Upload More'
      : 'Upload Files';
    const secondary = mediasLength;
    const isLoading = uploadMediaStatus === LOADING;
    const isError = uploadMediaStatus === ERROR;

    return (
      <div className={uploadMediaClassNames}>
        <LoadingOverlay visible={isLoading} />
        <ErrorModal
          requestClose={resetStore}
          visible={isError}
          error={uploadMediaError}
        />
        <div className="main-label">
          <span>
            Upload Media Files
          </span>
        </div>
        <MediaLibrary value={selectedMedias} deleteHandler={this.deleteItem} />
        <MediaInput
          changeHandler={this.mediaChangeHandler}
          secondary={secondary}
          buttonLabel={buttonLabel}
          accept="image/jpg, image/png, image/jpeg, video/mp4"
          value={selectedMedias}
        /> {this.renderNextButton(mediasLength)}
      </div>
    );
  }
}

export default UploadMedia;



// WEBPACK FOOTER //
// ./src/containers/UploadMedia/UploadMedia.js